import { useSortable } from '@dnd-kit/sortable';
import { MoveCustom, ViewHideLight, EyeLight, PinFillLeft as PinIcon } from '@repo/go-icons';
import { Button, Switch } from '@repo/go-ui';
import clsx from 'clsx';
import { observer } from 'mobx-react-lite';

import styles from './DisplaySettingItem.module.scss';

type Props = {
  field: string;
  isPinned?: boolean;
  isVisible: boolean;
  isVisibilitySwitcherDisabled: boolean;
  isDragDisabled?: boolean;
  title?: string;
  onColumnVisibilityChange(column: string, value: boolean): void;
};

export const DisplaySettingItem = observer<Props>(function DisplaySettingItem({
  field,
  title,
  isPinned = false,
  isVisible,
  isDragDisabled = false,
  onColumnVisibilityChange,
  isVisibilitySwitcherDisabled,
}) {
  const isDragHandleDisabled = isDragDisabled || isPinned;
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
    id: field,
    disabled: isDragHandleDisabled,
  });

  const style = {
    transform: transform ? `translate(0, ${transform.y}px) scaleX(1) scaleY(1)` : undefined,
    transition,
  };

  return (
    <div ref={setNodeRef} className={clsx(styles.settingItem, isPinned && styles.settingItemPinned)} style={style}>
      <div className={styles.leftColumn}>
        <Button
          variant="flat"
          disabled={isDragHandleDisabled}
          {...listeners}
          {...attributes}
          className={styles.draggingButton}
        >
          <MoveCustom />
        </Button>

        {isPinned && <PinIcon className={styles.pinIcon} />}

        <Switch
          leftNode={<ViewHideLight />}
          rightNode={<EyeLight />}
          checked={isVisible}
          disabled={isVisibilitySwitcherDisabled}
          onChange={(value) => onColumnVisibilityChange(field, value)}
        />
        <p>{title}</p>
      </div>
    </div>
  );
});
